import {nexusDebugLog} from './nexus-debug-log';

/** Normalize saveProjectSb3 output (Blob, ArrayBuffer, TypedArray) to Uint8Array. */
export const projectContentToUint8Array = async content => {
    if (!content) {
        throw new Error('Project content is empty');
    }
    if (content instanceof Blob) {
        const buffer = await content.arrayBuffer();
        return new Uint8Array(buffer);
    }
    if (content instanceof ArrayBuffer) {
        return new Uint8Array(content);
    }
    if (ArrayBuffer.isView(content)) {
        return new Uint8Array(content.buffer, content.byteOffset, content.byteLength);
    }
    throw new Error('Unsupported project content type');
};

export const getProjectByteLength = content => {
    if (!content) return 0;
    if (content instanceof Blob) return content.size;
    if (content instanceof ArrayBuffer) return content.byteLength;
    if (ArrayBuffer.isView(content)) return content.byteLength;
    return 0;
};

export const uint8ArrayToBase64 = bytes => {
    let binary = '';
    const chunk = 0x8000;
    for (let i = 0; i < bytes.length; i += chunk) {
        binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
    }
    return btoa(binary);
};

/** Encode for postMessage — base64 avoids Blob clone quirks cross-origin. */
export const encodeProjectForBridge = async content => {
    const bytes = await projectContentToUint8Array(content);
    nexusDebugLog('NexusBlocks', 'Encoded project for bridge', {bytes: bytes.byteLength});
    return {
        projectBase64: uint8ArrayToBase64(bytes),
        byteLength: bytes.byteLength
    };
};

export const decodeProjectFromBridge = payload => {
    if (payload && payload.projectBase64) {
        const binary = atob(payload.projectBase64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
    }
    if (payload && payload.project instanceof Blob) {
        return payload.project;
    }
    if (payload && payload.project) {
        return payload.project;
    }
    throw new Error('Missing project data in bridge payload');
};
